import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import truncate from 'lodash/truncate';
import cx from 'classnames';
import { observer } from 'mobx-react';
import RadialProgress from '../../../../components/RadialProgress';
import Icon from '../../../../components/Icon';
import DeleteIcon from '../../../../assets/icons/delete.i.svg';
import { Dropdown, DropdownItem, DropdownItemIcon, DropdownItemIconSvg } from '../../../../components/Dropdown';
import IconButton from '../../../../components/IconButton';
import Avatar from '../../../../components/Avatar';
import DocumentTagsStrip, { DocumentTag } from '../../DocumentTagsStrip';
import RequirePerms from '../../../../iam/containers/RequirePerms';
import ConfirmDialog from '../../../../components/ConfirmDialog';
import DocumentInspectorState from '../../../views/DocumentInspector/DocumentInspectorState';
import styles from './DocumentItem.m.sass';
import { isMobile } from '../../../../utils/mobileDetect';
var DocumentItem = function DocumentItem(_ref) {
  var document = _ref.document,
    documentStore = _ref.documentStore,
    jobId = _ref.jobId,
    useAccessDate = _ref.useAccessDate,
    indented = _ref.indented,
    _ref$onSelectedChange = _ref.onSelectedChange,
    onSelectedChange = _ref$onSelectedChange === void 0 ? null : _ref$onSelectedChange,
    onPerformDelete = _ref.onPerformDelete;
  var access = document.accesses.find(function (access) {
    return access.jobId === jobId;
  });
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    checked = _useState2[0],
    setChecked = _useState2[1];
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.root, indented && styles.indented)
  }, onSelectedChange && /*#__PURE__*/React.createElement("input", {
    className: cx(styles.checkbox),
    checked: checked,
    type: "checkbox",
    onChange: function onChange(e) {
      var _e$target, _e$target2;
      setChecked((e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.checked) || false);
      onSelectedChange(document.id, (e === null || e === void 0 ? void 0 : (_e$target2 = e.target) === null || _e$target2 === void 0 ? void 0 : _e$target2.checked) || false);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.info
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.title,
    title: document.title
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.titlePrimary
  }, truncate(document.title, {
    length: 80
  })), useAccessDate && access ? access.dateCreated && /*#__PURE__*/React.createElement("span", {
    className: styles.titleDetail,
    title: "Created ".concat(access.dateCreated.format('LL LT'))
  }, access.dateCreated.format('L LT')) : document.dateModified && /*#__PURE__*/React.createElement("span", {
    className: styles.titleDetail,
    title: "Created ".concat(document.dateModified.format('LL LT'))
  }, document.dateModified.format('L LT'))), /*#__PURE__*/React.createElement("p", {
    className: styles.description,
    title: document.description
  }, truncate(document.description, {
    length: 60
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.meta
  }, document.collaborators.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: styles.metaItem
  }, /*#__PURE__*/React.createElement(Collaborators, {
    document: document
  })), document.documentType && /*#__PURE__*/React.createElement("div", {
    className: styles.metaItem
  }, /*#__PURE__*/React.createElement(DocumentTag, {
    tag: {
      label: document.documentType.name
    }
  })), !document.documentType && document.tags.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: styles.metaItem
  }, /*#__PURE__*/React.createElement(DocumentTagsStrip, {
    tags: document.tags
  })))), /*#__PURE__*/React.createElement("div", {
    className: styles.actions
  }, /*#__PURE__*/React.createElement(ItemAction, {
    onPerformDelete: onPerformDelete,
    document: document,
    documentStore: documentStore
  })));
};
var ItemAction = observer(function (_ref2) {
  var document = _ref2.document,
    documentStore = _ref2.documentStore,
    onPerformDelete = _ref2.onPerformDelete;
  if (document.uploadProgress) {
    return /*#__PURE__*/React.createElement(RadialProgress, {
      size: 32,
      progress: document.uploadProgress.percent
    });
  }
  if (!(document.latestVersion && !document.latestVersion.purged)) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.purged
    }, "Purged");
  }
  var view = new DocumentInspectorState({
    document: document
  }, {
    rootStore: documentStore.rootStore,
    performDelete: onPerformDelete,
    close: function close() {}
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ConfirmDialog, {
    position: !isMobile() && 'top',
    title: "Remove this document?",
    yes: "Remove Document",
    danger: true,
    state: view.confirmDocumentDelete,
    compact: true,
    hideOverlayDismiss: true
  }), /*#__PURE__*/React.createElement(Dropdown, {
    position: "right",
    button: function button(buttonProps) {
      return /*#__PURE__*/React.createElement(IconButton, buttonProps, /*#__PURE__*/React.createElement(ItemIcon, {
        document: document
      }));
    }
  }, /*#__PURE__*/React.createElement(DetailsAction, {
    document: document,
    documentStore: documentStore
  }), /*#__PURE__*/React.createElement(ItemDownload, {
    document: document,
    documentStore: documentStore
  }), /*#__PURE__*/React.createElement(DeleteAction, {
    rootStore: documentStore.rootStore,
    view: view
  })));
});
var ItemIcon = observer(function (_ref3) {
  var document = _ref3.document;
  switch (document.latestVersion.state) {
    case 'Pending':
      return /*#__PURE__*/React.createElement("span", {
        className: styles.status,
        title: "This document is waiting for a virus scan to complete"
      }, /*#__PURE__*/React.createElement(Icon, {
        auto: true,
        material: true,
        name: "hourglass empty"
      }));
    case 'Scanning':
      return /*#__PURE__*/React.createElement("span", {
        className: styles.status,
        title: "This document is currently undergoing a virus scan"
      }, /*#__PURE__*/React.createElement(Icon, {
        auto: true,
        material: true,
        name: "sync"
      }));
    case 'Downloadable':
      return /*#__PURE__*/React.createElement("div", {
        "data-test": 'download-actions-dropdown-' + document.title
      }, /*#__PURE__*/React.createElement(Icon, {
        material: true,
        name: "more vert"
      }));
    case 'VerifyingClientData':
      return /*#__PURE__*/React.createElement("span", {
        className: styles.status,
        title: "This document is currently undergoing a client data verification"
      }, /*#__PURE__*/React.createElement(Icon, {
        auto: true,
        material: true,
        name: "sync"
      }));
    case 'ManualVerificationRequired':
      return /*#__PURE__*/React.createElement("span", {
        className: styles.status,
        title: "This document requires manual verification"
      }, /*#__PURE__*/React.createElement(Icon, {
        auto: true,
        material: true,
        name: "warning"
      }));
    case 'Failed':
      return /*#__PURE__*/React.createElement("span", {
        className: cx(styles.status, styles.failed),
        title: "This document failed to upload and is not available for download"
      }, /*#__PURE__*/React.createElement(Icon, {
        auto: true,
        material: true,
        name: "error outline"
      }));
    case 'Purged':
      return /*#__PURE__*/React.createElement("span", {
        className: cx(styles.status, styles.virus),
        title: "This document is infected with a virus and is not available for download"
      }, /*#__PURE__*/React.createElement(Icon, {
        auto: true,
        material: true,
        name: "bug report"
      }));
  }
});
var ItemDownload = observer(function (_ref4) {
  var document = _ref4.document,
    documentStore = _ref4.documentStore;
  if (document.latestVersion.downloadable) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, !documentStore.isMobile && /*#__PURE__*/React.createElement(ViewInlineAction, {
      document: document,
      documentStore: documentStore,
      dataTest: 'download-actions-dropdown-item-viewinline-' + document.title
    }), /*#__PURE__*/React.createElement(DownloadAction, {
      document: document,
      documentStore: documentStore,
      dataTest: 'download-actions-dropdown-item-download-' + document.title
    }));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null);
});
var Collaborators = observer(function Collaborators(_ref5) {
  var document = _ref5.document;
  var users = document.collaborators.filter(function (x) {
    return x.avatar;
  });
  var toShow = users.length === 4 ? users : users.slice(0, 3);
  var more = users.length - toShow.length;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.collaborators
  }, toShow.map(function (u) {
    return /*#__PURE__*/React.createElement(Collaborator, {
      key: u.userId,
      user: u
    });
  }), more > 0 && /*#__PURE__*/React.createElement("div", {
    className: styles.more,
    title: "".concat(more, " more collaborators")
  }, "+", more));
});
var Collaborator = observer(function Collaborator(_ref6) {
  var user = _ref6.user;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.collaborator,
    title: user.displayName
  }, /*#__PURE__*/React.createElement(Avatar, {
    square: true,
    url: user.avatar,
    fallback: user.avatarFallback,
    size: 24
  }));
});
var DownloadAction = observer(function DownloadAction(_ref7) {
  var document = _ref7.document,
    documentStore = _ref7.documentStore,
    dataTest = _ref7.dataTest;
  if (!(document.latestVersion && document.latestVersion.downloadable)) {
    return null;
  }
  var isMobileApp = window.localStorage.getItem('accessOrigin') === 'mobile';
  return /*#__PURE__*/React.createElement("div", {
    "data-test": dataTest
  }, /*#__PURE__*/React.createElement(DropdownItem, {
    onClick: function onClick(e) {
      return e.stopPropagation() || documentStore.download(document, false);
    }
  }, /*#__PURE__*/React.createElement(DropdownItemIcon, {
    auto: true,
    material: true,
    name: "file download"
  }), isMobileApp ? 'Open' : 'Download'));
});
var ViewInlineAction = observer(function ViewInlineAction(_ref8) {
  var document = _ref8.document,
    documentStore = _ref8.documentStore,
    dataTest = _ref8.dataTest;
  if (!(document.latestVersion && document.latestVersion.downloadable)) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    "data-test": dataTest
  }, /*#__PURE__*/React.createElement(DropdownItem, {
    onClick: function onClick(e) {
      return e.stopPropagation() || documentStore.download(document, true);
    }
  }, /*#__PURE__*/React.createElement(DropdownItemIcon, {
    auto: true,
    material: true,
    name: "visibility"
  }), "Open"));
});
var DetailsAction = observer(function ViewInlineAction(_ref9) {
  var document = _ref9.document,
    documentStore = _ref9.documentStore,
    dataTest = _ref9.dataTest;
  return /*#__PURE__*/React.createElement("div", {
    "data-test": dataTest
  }, /*#__PURE__*/React.createElement(DropdownItem, {
    onClick: function onClick(e) {
      return e.stopPropagation() || documentStore.viewDocument(document);
    }
  }, /*#__PURE__*/React.createElement(DropdownItemIcon, {
    auto: true,
    material: true,
    name: "assignment"
  }), "Details"));
});
var DeleteAction = observer(function DeleteAction(_ref10) {
  var rootStore = _ref10.rootStore,
    view = _ref10.view,
    dataTest = _ref10.dataTest;
  return /*#__PURE__*/React.createElement(RequirePerms, {
    rootStore: rootStore,
    anyOf: ['DOCS_SELF_REMOVE', 'DOCS_CLIENT_REMOVE', 'DOCS_PROVIDER_REMOVE']
  }, /*#__PURE__*/React.createElement("div", {
    "data-test": dataTest
  }, /*#__PURE__*/React.createElement(DropdownItem, {
    onClick: view.remove
  }, /*#__PURE__*/React.createElement(DropdownItemIconSvg, null, /*#__PURE__*/React.createElement(DeleteIcon, null)), "Delete")));
});
export default observer(DocumentItem);
//# sourceMappingURL=index.js.map
